// extracted by mini-css-extract-plugin
module.exports = {"noOutline":"AllocationByResourceTypeChart_noOutline__2LJeQ"};